import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ImageUrlManager } from '@biletix/core/common/helper/image-url-manager';
import { VenueSeatPlanImageModalComponent } from './venue-seat-plan-image-modal/venue-seat-plan-image-modal.component';

@Component({
    standalone: false,
    selector: 'btx-venue-seat-plan',
    templateUrl: './venue-seat-plan.component.html',
    styleUrls: ['./venue-seat-plan.component.scss']
})
export class VenueSeatPlanComponent {

    @Input("seatPlanImage") seatPlanImage!: string;

    constructor(private dialog: MatDialog) {}

    get seatPlanImageUrl(): string {
        return ImageUrlManager.createSeatPLanImage(this.seatPlanImage || 'noseat.gif');
    }

    openSeatPlanModal(): void {
        if (!this.seatPlanImage) return;
        this.dialog.open(VenueSeatPlanImageModalComponent, {
            width: '95vw',
            maxWidth: '1220px',
            maxHeight: '90vh',
            data: {
                seatPlanImage: this.seatPlanImage || 'noseat.gif'
            }
        });
    }

    onImageError(event: Event): void {
        const imgElement = event.target as HTMLImageElement;
        if (imgElement && !imgElement.src.includes('noseat.gif')) {
            imgElement.src = ImageUrlManager.createSeatPLanImage('noseat.gif');
        }
    }
}
